import { makeStyles } from '@material-ui/core/styles';

export const useStoreStyles = makeStyles(() => ({
  container: {
    marginTop: (props) => (props.mobile ? null : 52),
    textAlign: 'center',
    maxWidth: 700,
    margin: '0 auto',
  },
  image: {
    width: 114,
    height: 100,
  },
  title: {
    fontSize: (props) => (props.mobile ? 20 : 26),
    fontWeight: 600,
    marginTop: 15,
    textAlign: 'center',
  },
}));
